/** REST client: same-origin /api in dev (Vite proxy), https://api.dukunai.com in production. */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? "/api";

export class ApiError extends Error { constructor(readonly status: number, msg: string) { super(msg); } }

export async function api<T = Record<string, unknown>>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const r = await fetch(API_BASE + path, {
    method: init.method ?? "GET",
    credentials: "include",
    headers: { "content-type": "application/json", "x-requested-with": "dukun-web" },
    ...(init.body === undefined ? {} : { body: JSON.stringify(init.body) }),
  });
  const j = (await r.json().catch(() => ({}))) as T & { error?: string };
  if (!r.ok) throw new ApiError(r.status, j.error ?? `Request failed (${r.status})`);
  return j;
}

export function wsUrl(path: string): string {
  const base = API_BASE.startsWith("http") ? API_BASE : `${location.origin}${API_BASE}`;
  return base.replace(/^http/, "ws") + path;
}
